import styled from "styled-components";
import { mediaMaxWidth, mediaMinWidth } from "../../utils/mediaQueriesTemplate";
import zIndexTypes from "../../../theme/zIndexTypes";

export const QuestionMark = styled.div`
  position: fixed;
  top: 73px;
  right: 10px;
  z-index: ${zIndexTypes.actionBarItem};
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #402680;
  width: 30px;
  height: 30px;
  display: none;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease-in-out;
  cursor: pointer;

  @keyframes bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }

    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }

    75% {
      transform: translate3d(10px, 0, 0);
    }

    90% {
      transform: translate3d(-5px, 0, 0);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  &.bounceInRight {
    animation-name: bounceInRight;
  }

  &.animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  svg {
    color: #402680;
    font-size: 1.5em;
    transition: 0.2s ease-in-out;
  }

  &:hover {
    border: 1px solid #79D9D9;

    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.smallDesktop`
    display: none;
  `}
`;

export const BackDrop = styled.div`
  background-color: rgba(0, 0, 0, 0.85);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn,
  &.fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .animated,
  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
    display: flex;
  }

  .delayOne {
    animation-delay: 0.2s;
    animation-duration: 0.4s;
  }

  .delayTwo {
    animation-delay: 0.2s;
    animation-duration: 0.5s;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;

  svg {
    color: #fff;
    font-size: 1.8em;
    transition: 0.2s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }
`;

export const GraphicsWrapper = styled.div`
  height: 600px;
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .slick-slider {
    .slick-list {
      margin-bottom: 30px;
    }

    .slick-dots {
      li {
        width: 40px;
      }

      button:before {
        color: #fff;
        font-size: 16px;
        opacity: 0.25;
      }

      li.slick-active button:before {
        opacity: 1;
      }
    }
  }

  ${mediaMaxWidth.tablet`
    width: 85vw;
  `}

  ${mediaMaxWidth.phone`
    height: 90vh;
    width: 95vw;

    .slick-slider {
      .slick-list {
        margin-bottom: 10px;
      }
    }
  `}
`;

export const Graphics = styled.div`
  display: flex;
  flex: 4;
  width: 500px;
  align-items: center;
  justify-content: center;

  ${mediaMaxWidth.tablet`
    width: 80vw;
  `}

  ${mediaMaxWidth.phone`
    width: 95vw;
  `}
`;

export const Description = styled.div`
  flex: 1;
  color: #fff;
  text-align: center;
  margin-top: 40px;
  width: 500px;
  font-size: 1.05em;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.tablet`
    width: 85vw;
  `}

  ${mediaMinWidth.phone`
    display: ${(props) => props.mobile && "none"};
  `}

  ${mediaMaxWidth.phone`
    display: ${(props) => props.desktop && "none"};
    width: 95vw;
    font-size: 0.9em;
  `}
`;

export const Slide = styled.div`
  &:focus {
    outline: none;
  }
`;

export const Animation = styled.img`
  width: 700px;
  border-radius: 8px;

  ${mediaMaxWidth.tablet`
    width: 85vw;
  `}

  ${mediaMaxWidth.phone`
    width: 95vw;
    width: ${(props) => props.mobile && "180px"};
  `}
`;
